// extracted by mini-css-extract-plugin
module.exports = {"header":"LandingLayout_header__2QVGD","logo":"LandingLayout_logo__2WcwU","layout":"LandingLayout_layout__RU_JH"};